import React from "react";
import "./CV.css";
import { useNavigate } from 'react-router-dom';

const timeline = [
  {
    title: "Licence et Master recherche en psychologie & neuroscience",
    location: "Université de Tours 🇫🇷",
    date: "2010-2015",
    extra: "Senior year à l'université de Bucknell (Pennsylvanie, USA 🇺🇸)",
  },
  {
    title: "Doctorat - apprentissage automatique et profond sur données de santé",
    location: "Université RWTH, Aachen, Allemagne 🇩🇪",
    date: "2015-2019",
    extra: "Apprentissage automatique sur signal IRM et données tabulaires",
  },
  {
    title: "Chercheur - apprentissage automatique et profond sur données de santé",
    location: "Post-doctorats à BIIC lab, NTHU, Taiwan 🇹🇼 · INSERM, Caen 🇫🇷 · INRIA, Rennes 🇫🇷",
    date: "2019-2024",
    extra: "Apprentissage automatique et profond sur signal IRM, analyses multivers, méta-analyses, reproductibilité des analyses statistiques",
  },
  {
    title: "Ingénieur IA embarquée",
    location: "Agence Ministérielle pour l'IA de Défense (AMIAD), Bruz 🇫🇷",
    date: "2025-2026",
    extra: "Optimisation avancée de modèles IA : entraînement, fine-tuning, réduction et intégration sur des architectures SoB.",
  },
];

const currentRole = [
  {
    title: "Ingénieur IA embarquée sénior et responsable de projets d'IA embarquée",
    location: "Agence Ministérielle pour l'IA de Défense (AMIAD), Bruz 🇫🇷",
    date: "2026-Aujourd'hui",
    extra: "Arbitrage et priorisation de la roadmap, choix de direction technique IA, suivi de projets (Agile/Scrum), démarchage et tests produit, encadrement du développement de POC.",
  },
];

const extras = [
  {
    title: "Électronique",
    location: "Rennes",
    date: "2024-Aujourd'hui",
    extra: "Responsable adjoint du Fablab de la DGA-MI ; Président de l'association d'électronique 'PartageTaCo35' à l'EDULAB de Rennes",
    link: { label: "partagetaco35.github.io ↗", url: "https://partagetaco35.github.io/" },
  },
  {
    title: "Enseignant",
    location: "Universités et écoles d'ingénieurs",
    date: "2016-Aujourd'hui",
    extra: "Cours magistraux, TD et TP en apprentissage automatique et profond, algorithmique et complexité, GIT et chaînes CI/CD, statistiques inférentielles, traitement d'images, Python",
  },
  {
    title: "Projets annexes",
    location: "Projets personnels",
    date: "2016-Aujourd'hui",
    extra: "Dev mobile (React Native), dev web (React, SQL, PHP), dev embarquée (Python, Rust, C++), mécatronique, domotique, impression 3D (FDM, SLS, résine)",
  },
];

const CVCard = ({ step }) => {
  const [dateStart, dateEnd] = step.date.split('-');
  return (
    <div className="cv-item">
      <span className="cv-item-date">{dateStart} -<br />{dateEnd}</span>
      <div className="cv-item-marker" />
      <div className="cv-item-body">
        <h2>{step.title}</h2>
        <p className="cv-item-meta">
          <span className="cv-item-location">{step.location}</span>
        </p>
        <p className="cv-item-extra">{step.extra}</p>
        {step.link && (
          <a className="info-link" href={step.link.url} target="_blank" rel="noopener noreferrer">
            {step.link.label}
          </a>
        )}
      </div>
    </div>
  );
};

const CV = () => {
  const navigate = useNavigate();
  const handleGoHome = () => navigate('/');

  return (
    <div className="cv-page">
      <div className="cv-container">
        <button className="home-button" onClick={handleGoHome}>← Back home</button>

        <h3 className="cv-section-title">Poste actuel</h3>
        <div className="cv-timeline">
          {currentRole.map((step, index) => (
            <CVCard step={step} key={index} />
          ))}
        </div>

        <h3 className="cv-section-title">Parcours</h3>
        <div className="cv-timeline">
          {timeline.map((step, index) => (
            <CVCard step={step} key={index} />
          ))}
        </div>

        <h3 className="cv-section-title">Extra curriculum</h3>
        <div className="cv-timeline">
          {extras.map((step, index) => (
            <CVCard step={step} key={index} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default CV;
